import { useTranslation } from "react-i18next";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useSurfaceTreatmentSelect } from "#modules/quoteRequestLinesV2/hooks/useSurfaceTreatmentSelect";
import { SurfaceTreatmentSelect } from "#modules/quoteRequestLinesV2/view/molecules/SurfaceTreatmentSelect";

type Props = {
  line: QuoteRequestLineDto;
};

export const SurfaceTreatmentCell = ({ line }: Props) => {
  const { data, value, onChange } = useSurfaceTreatmentSelect([line.id]);
  const { t } = useTranslation();

  return (
    <SurfaceTreatmentSelect
      data={data}
      value={value}
      onChange={onChange}
      placeholder={t("quoteRequestV2.column.treatmentsPlaceholder")}
    />
  );
};
